import React from "react";
import { Images } from "../../../../core/utilities/images";
import ContentKey from "../../../ContentKey/ContentKey";
import "./Reward.scss";

interface IProps {
  rewardKey: string;
}

const Reward = (props: IProps) => {
  return (
    <div id="reward">
      <div className="d-flex">
        <img className="reward-icon" src={Images.offer_icon_gift} alt="gift" />
        <ContentKey className="reward-text" contentKey={props.rewardKey} />
      </div>
      <span className="note text-xxsmall">FREEBYTE</span>
    </div>
  );
};

export default Reward;
